// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dialog {
  width: 80%;
  height: auto;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

dialog::backdrop {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(2px);
}

html:has(dialog[open]) {
  overflow: hidden;
}

.ys-modal-dialog {
  position: fixed;
}

.ys-modal-close-button {
  position: absolute;
  top: 25px;
  left: 25px;
  z-index: 10;
  border-radius: 0.5rem;
  /* background: #595959; */
  /* border: 1px solid #e5e7eb; */
  /* cursor: pointer; */
  /* line-height: 1; */
}

.tab-marche .yousign-iframe-container {
  width: 100%;
  /* margin: 2rem 0; */
  border: none !important;
  overflow: hidden;
}

.signature-pending > h4 {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Marche/Marche.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["dialog {\n  width: 80%;\n  height: auto;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n}\n\ndialog::backdrop {\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(2px);\n}\n\nhtml:has(dialog[open]) {\n  overflow: hidden;\n}\n\n.ys-modal-dialog {\n  position: fixed;\n}\n\n.ys-modal-close-button {\n  position: absolute;\n  top: 25px;\n  left: 25px;\n  z-index: 10;\n  border-radius: 0.5rem;\n  /* background: #595959; */\n  /* border: 1px solid #e5e7eb; */\n  /* cursor: pointer; */\n  /* line-height: 1; */\n}\n\n.tab-marche .yousign-iframe-container {\n  width: 100%;\n  /* margin: 2rem 0; */\n  border: none !important;\n  overflow: hidden;\n}\n\n.signature-pending > h4 {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
